import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import css from './CalloutCard.scss';

export const CalloutCard = props => {
  const { callout, calloutNote, ctaCopy, details, extraClass, onClick: handleClick, selected, tag } = props;

  return (
    <div
      className={cx(
        css.base,
        {
          [css['base--selected']]: selected,
        },
        extraClass
      )}
      onClick={handleClick}>
      <div className={cx(css.base__choice, 'md-hidden')}>
        <input type="radio" checked={selected} readOnly />
      </div>
      <div className={css.base__content}>
        {tag && (
          <div className={css.base__tag}>
            <span>{tag}</span>
          </div>
        )}
        <div className={css.base__top}>
          <div className={css.base__callout}>{callout}</div>
          {calloutNote && <p className={css.base__note}>{calloutNote}</p>}
          {details && <div className={css.base__details}>{details}</div>}
        </div>
        <div className="md-block hidden">
          <button className={cx(css.base__bt, 'bt bt--primary bt--lg bt--width-full')}>{ctaCopy}</button>
        </div>
        <div className="md-block hidden">{props.children}</div>
      </div>
    </div>
  );
};

CalloutCard.propTypes = {
  callout: PropTypes.node.isRequired,
  calloutNote: PropTypes.node,
  children: PropTypes.node,
  ctaCopy: PropTypes.node.isRequired,
  extraClass: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  details: PropTypes.node,
  tag: PropTypes.node,
};
